import { useEffect, useState } from 'react';
import { collection, query, where, getDocs } from 'firebase/firestore';
import { auth, db } from '../Firebase_Config/firebase';
import Snackbar from '@mui/material/Snackbar';
import MuiAlert from '@mui/material/Alert';
import './ContactForm.css';

//https://web3forms.com/

const GET_EMAIL = () => {
  const [formData, setFormData] = useState({ name: '', email: '', message: '' });

  const [toastOpen, setToastOpen] = useState(false);
  const [toastSeverity, setToastSeverity] = useState('success');
  const [toastMessage, setToastMessage] = useState('');

  useEffect(() => {
    const fetchUserData = async () => {
      const user = auth.currentUser;
      if (!user) return;

      const userDocQuery = query(collection(db, 'users'), where('userId', '==', user.uid));
      const userDocSnapshot = await getDocs(userDocQuery);

      if (!userDocSnapshot.empty) {
        const userData = userDocSnapshot.docs[0].data();
        setFormData(prev => ({
          ...prev,
          name: userData.Name || '',
          email: userData.email || ''
        }));
      }
    };

    fetchUserData();
  }, []);

  const handleChange = (e) => {
    setFormData({ ...formData, message: e.target.value });
  };

  const showToast = (message, severity = 'success') => {
    setToastMessage(message);
    setToastSeverity(severity);
    setToastOpen(true);
  };

  const handleCloseToast = (_, reason) => {
    if (reason === 'clickaway') return;
    setToastOpen(false);
  };

  const onSubmit = async (event) => {
    event.preventDefault();

    const formDataToSend = {
      ...formData,
      access_key: "eeb7e415-06eb-495c-a9f8-075545b91e36"
    };

    const res = await fetch("https://api.web3forms.com/submit", {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Accept: "application/json"
      },
      body: JSON.stringify(formDataToSend)
    }).then((res) => res.json());

    if (res.success) {
      showToast("Email submitted successfully!", "success");
      setFormData(prev => ({ ...prev, message: '' }));
    } else {
      showToast("Failed to submit. Please try again.", "error");
    }
  };

  return (
    <div className="ContactContainer">
      <div className='Hom-card-accent'/>
      <form onSubmit={onSubmit}>
        <textarea
          className='OtherInputs'
          name="message"
          placeholder="Write Your Message Here.."
          value={formData.message}
          onChange={handleChange}
        />
        <button className='SubmitInput' type="submit">Submit Form</button>
      </form>

      <Snackbar open={toastOpen} autoHideDuration={4000} onClose={handleCloseToast} anchorOrigin={{ vertical: 'top', horizontal: 'center' }}>
        <MuiAlert onClose={handleCloseToast} severity={toastSeverity} sx={{ width: '100%' }} elevation={6} variant="filled">
          {toastMessage}
        </MuiAlert>
      </Snackbar>
    </div>
  );
};



const ContactForm = () => {
  

  return (
    <div className='HomBG'>
      <div className='HelpMainContent'>
        <div className='bannerBG'>
          <img src="banner.png" alt="banner" className='banner-image' />
        </div>
        <br/>
         <h1 className='helptitle bigger'>Contact Form</h1>
        <br/>
        <GET_EMAIL/>
      </div>
    </div>
  );
};

export default ContactForm;
